// extracted by mini-css-extract-plugin
module.exports = {"scrollToTopBtn":"ScrollTopBtn_scrollToTopBtn__yQOdH"};